document.addEventListener('DOMContentLoaded', function () {
    initSeoKeywords();
});

document.addEventListener('shopify:section:load', function (event) {
    initSeoKeywords(event.target);
});

function initSeoKeywords(container) {
    var scope = container || document;

    scope.querySelectorAll('.seo-keywords').forEach(function (root) {
        if (root.dataset.initialized === 'true') {
            return;
        }

        root.dataset.initialized = 'true';

        var list = root.querySelector('.seo-keywords__list');
        var toggleButton = root.querySelector('.seo-keywords__toggle');
        var toggleText = root.querySelector('.seo-keywords__toggle-text');

        if (!list || !toggleButton || !toggleText) {
            return;
        }

        var seeMoreText = toggleButton.dataset.seeMore;
        var seeLessText = toggleButton.dataset.seeLess;

        function syncToggleVisibility() {
            if (list.classList.contains('expanded')) {
                toggleButton.hidden = false;
                return;
            }

            toggleButton.hidden = list.scrollWidth <= list.clientWidth + 1;
        }

        toggleButton.addEventListener('click', function () {
            var isExpanded = list.classList.toggle('expanded');

            toggleButton.classList.toggle('expanded', isExpanded);
            toggleButton.setAttribute(
                'aria-expanded',
                isExpanded ? 'true' : 'false'
            );

            toggleText.textContent = isExpanded
                ? seeLessText
                : seeMoreText;

            syncToggleVisibility();
        });

        window.addEventListener('resize', syncToggleVisibility);

        requestAnimationFrame(syncToggleVisibility);
    });
}